import curd from '../curd'

const BASE_PATH = '/site/category'

export default curd(BASE_PATH)



// WEBPACK FOOTER //
// ./src/apis/modules/SiteCategory.js